export default "__VITE_ASSET__625dca3d__"